import {
  FontWeight, Grid, Spacing, SpacingName, Typography, Image,
} from '@doveit/lego';
import React from 'react';
import * as styles from './StatsBlock.style';

export interface StatsBlockProps {
  imageUrl: string,
  imageAlt: string,
  items: {
    title: string,
    decription: string,
  }[],
}

const StatsBlock: React.FC<StatsBlockProps> = ({
  imageUrl,
  imageAlt,
  items,
}) => (
  <Grid gutter={SpacingName.MEDIUM}>
    <Grid.Unit size={{ LG: 2 / 4 }}>
      <Image
        src={imageUrl}
        alt={imageAlt}
        lazyLoad
        responsive
      />
    </Grid.Unit>
    <Grid.Unit size={{ LG: 2 / 4 }}>
      <div css={styles.content}>
        {items.map((stat, i) => (
          <Spacing key={stat.title} margin={i !== 0 ? [SpacingName.MEDIUM, 0, 0] : 0}>
            <Typography.H2 color="brand.primary">
              {stat.title}
            </Typography.H2>
            <Spacing margin={[SpacingName.SMALLEST, 0, 0]}>
              <Typography.H4
                tagName="p"
                fontWeight={FontWeight.LIGHT}
                color="neutrals.dark"
              >
                {stat.decription}
              </Typography.H4>
            </Spacing>
          </Spacing>
        ))}
      </div>
    </Grid.Unit>
  </Grid>
);

export default StatsBlock;
